<template>
  <b-card>
    <avito-area-form v-if="area" :initial-area="area"/>
  </b-card>
</template>

<script>
import AvitoAreaForm from "@/components/AvitoAreaForm";

export default {
  name: "AvitoAreaEdit",
  components: {AvitoAreaForm},
  data() {
    return {
      area: false
    }
  },
  mounted() {
    let _this = this;
    this.$store.dispatch('siteModule/fetchAvitoAreas', {
      id: this.$route.params.id
    }).then(function (response) {
      // Assuming the API returns a single area when id is provided
      if (response.data && response.data.length > 0) {
        _this.area = response.data[0];
      } else {
        // Handle case where area is not found
        _this.$router.push('/avito-areas');
      }
    }).catch(function (error) {
      console.error('Error fetching area:', error);
      _this.$router.push('/avito-areas');
    });
  }
}
</script>
